import React from "react";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { MdBankCustomer } from "../../../dist/generated/MdBankCustomer";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

interface StepperProps {
  data: MdBankCustomer[];
  currentTabIndex: number;
  rerender: (customer: string, step: number) => void;
  currentCustomer: string;
}

export default function DotsMobileStepper(props: StepperProps) {
  const classes = useStyles();
  const theme = useTheme();

  const currentCutomerIndex = props.data.findIndex((ele: any)=> ele.customerNum == props.currentCustomer);

  const handleNext = () => {
    if (currentCutomerIndex + 1 >= props.data.length) return;
    props.rerender(props.data[currentCutomerIndex + 1].customerNum, props.currentTabIndex);
  };

  const handleBack = () => {
    if (currentCutomerIndex - 1 < 0) return;
    props.rerender(props.data[currentCutomerIndex - 1].customerNum, props.currentTabIndex);
  };

  return (
    <MobileStepper
      variant="text"
      steps={props.data.length}
      position="static"
      activeStep={currentCutomerIndex}
      className={classes.root}
      nextButton={
        <Button
          size="small"
          onClick={handleNext}
          disabled={currentCutomerIndex === props.data.length - 1}
        >
          Next{" "}
          {props.data.length > currentCutomerIndex + 1 &&
            props.data[currentCutomerIndex + 1].customerNum}
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </Button>
      }
      backButton={
        <Button size="small" onClick={handleBack} disabled={currentCutomerIndex === 0}>
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
          Back {currentCutomerIndex - 1 >= 0 && props.data[currentCutomerIndex - 1].customerNum}
        </Button>
      }
    />
  );
}
